var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"mt-5"},[_c('FollowupsTableFilter',{attrs:{"user":_vm.user}}),_c('FollowupsTable',{attrs:{"followups":_vm.filtered_followups,"user":_vm.user}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }